import { ErrorHandler } from "UI/Errors";
import { Localization } from "../../../../../OW.Remoting/Remoting/Localization";
import { GenericControl } from "../../../../UI.BaseControls/GenericControl";
import { EventHelper } from "../../../../UI.BaseControls/Helpers/EventHelper";
import { INodeAction } from "../../../../UI.Controls/Actions/INodeAction";
import { DropDownMenuHorizontalOpen } from "../../../../UI.Controls/DropDownMenu/DropDownInterfaces";
import { DropDownMenu } from "../../../../UI.Controls/DropDownMenu/DropDownMenu";
import { DropDownMenuComboItem } from "../../../../UI.Controls/DropDownMenu/DropDownMenuComboItem";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Icon, MenuTypes } from "../../FormUI/FormUI";
import { NodeAction } from "./NodeAction";
import { DesktopToolbarButton } from "./ToolbarButton";
import { ToolbarMenuButton } from "./ToolbarMenuButton";
import { WFAction } from "./WFAction";
import { XGAction } from "./XGAction";

/**Reprezentuje tlacitko v toolbaru*/
export class DesktopToolbarDropdownButton extends DesktopToolbarButton {
    //#region Fields
    private _dropDownMenu: DropDownMenu;
    private _leftBtn: HTMLButtonElement;
    private _rightBtn: HTMLButtonElement;
    //#endregion Fields

    //#region Listeners
    //#endregion Listeners

    //#region Properties
    public get dropDownMenu(): DropDownMenu {
        return this._dropDownMenu;
    }

    public set dropDownMenu(v: DropDownMenu) {
        this._dropDownMenu = v;
    }
    //#endregion Properties

    //#region Constructors
    constructor(icon: Icon | string, menuType: MenuTypes, action: XGAction, classes?: string[]) {
        super(icon, menuType, action, [], "div"); //TODO [WI-16116] Předělat na 2 buttony kvůli přístupnosti a firefoxu, který nepodoruje aby button měl uvnitř další interaktivní akce. Dočasně vráceno zpět na div, který to umožňuje.
        this.element.classList.add("ToolbarDropdownButton", "btn");
        if (classes && classes.length > 0)
            this.element.classList.add(...classes);

        this._createDropdownElement();
    }
    //#endregion Constructors

    //#region Methods
    protected override _setListeners(): void {
        //pokud je button zobrazen v contextovem menu, tak pri mouse over skryje subMenu v dalsi urovni
        if (this._menuType == 2)
            GenericControl.registerEventListener(this.element, "mouseover", (_e: MouseEvent) => {
                if (this.action.isActive && this.action instanceof INodeAction)
                    ((this.action.parentAction as NodeAction).toolbarButton as ToolbarMenuButton).closeSubMenuAndSetNew();
            });

        GenericControl.registerEventListener(this._leftBtn, "click", (e: MouseEvent) => {
            if (e.button === 0) { // uprava aby se akce volala jen pri stisku primarniho (leveho) tlacitka, jinak se akce provadel pri stisku jakehokoli tlacitka na mysi
                EventHelper.stopImmediatePropagation(e);

                if (!this.element.classList.contains("Disabled"))
                    this.action.execute();
            }
        });
    }

    protected override _createIconElement(): void {
        this._iconElement = document.createElement("div");

        this._iconElement.classList.add("Icon");

        if (this._menuType == 1) { //toolbar
            this._iconElement.classList.add("menuIcon");
            this._iconElement.classList.add(typeof this._icon === "string" ? this._icon : Icon[this._icon]);
        }

        //todo: potreba doresit pouziti u context menu
        if (this._menuType == 2) { //kontext. menu
            this._iconElement.classList.add("menuIcon");
            this._iconElement.classList.add(typeof this._icon === "string" ? this._icon : Icon[this._icon]);
        }
    }

    /**
     * Nastaveni eventu
     */
    protected override _createCaptionElement(): void {
        this._leftBtn = createElement({ type: "button", classes: "btn flat" }) as HTMLButtonElement;
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("btn-caption");

        if (this.locKey) {
            //Localization.addLocData(this.CaptionElement, this.locKey);
            Localization.getLocalizationItem(this.locKey).then((locItem) => {
                if (locItem.secondaryText) {
                    this.element.title = locItem.secondaryText;
                }
                this._captionElement.textContent = locItem.primaryText;
            }).catch((e) => ErrorHandler.instance.handleError(e));
        } else {
            if (this.action instanceof WFAction)
                this._captionElement.textContent = (this.action as WFAction).caption;
        }

        this._leftBtn.appendChild(this._iconElement);
        this._leftBtn.appendChild(this._captionElement);
        this.element.appendChild(this._leftBtn);
    }

    protected _createDropdownElement(): void {
        this._rightBtn = createElement({ type: "button", classes: "btn flat Arrow Icon ui-more-vertical" }) as HTMLButtonElement;

        GenericControl.registerEventListener(this._rightBtn, "click", (e) => {
            if (!this.element.classList.contains("Disabled"))
                this._dropDownMenu.show(this._rightBtn, e);
        });

        this.element.appendChild(this._rightBtn);
        this._dropDownMenu = new DropDownMenu();
        this._dropDownMenu.horizontalOpenPosition = DropDownMenuHorizontalOpen.right;

        this._dropdownmenuitem = new DropDownMenuComboItem();
        this._dropdownmenuitem.action = this.action;
    }

    //#endregion Methods

    //#region dispose
    public override dispose(): void {
        super.dispose();
        GenericControl.unregisterEventListener(this._leftBtn);
        GenericControl.unregisterEventListener(this._rightBtn);
        GenericControl.unregisterEventListener(this.element);
    }

    //#endregion dispose
}
